import styled from 'styled-components'
import { Box } from '../UI/Box'
import { CardProps } from '../Pools/PoolCard'
import { Background, ForceFullWidth } from '../Hero/styled'
import ProjectCards from '../../page_components/Home/parts/ProjectCards'
import { isEmpty } from 'ramda'
import { ReactNode } from 'react'

const Relative = styled.div`
  position: relative;
`

const SectionWrapper = styled(Box)`
  padding: 230px 0 60px;
  position: relative;
  z-index: 1;

  @media screen and (max-width: 768px) {
    padding: 147px 0 43px;
  }
`

const SectionTitle = styled.h3`
  color: ${({ theme }) => theme.semantics.zap.surface.primary};
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 32px;
  font-style: normal;
  font-weight: 300;
  line-height: 25px; /* 78.125% */
  letter-spacing: 9.6px;
  text-transform: uppercase;
  z-index: 1;

  em {
    font-style: normal;
    color: ${({ theme }) => theme.colors.brandPrimary};
  }

  @media screen and (max-width: 768px) {
    font-size: 24px;
    line-height: 32px; /* 133.333% */
    letter-spacing: 7.2px;
    max-width: 237px;
  }
`

export default function UpcomingProjects({
  backgroundUrl,
  title = 'Upcoming Projects',
  projects,
  loading = false,
  viewAllButton,
}: {
  backgroundUrl: string
  title?: ReactNode
  projects: CardProps[]
  loading: boolean
  viewAllButton?: ReactNode
}) {
  if (isEmpty(projects)) return null
  return (
    <Relative>
      <ForceFullWidth>
        <Background
          backgroundUrl={backgroundUrl}
          height="296px"
          mobileH="236px"
        />
      </ForceFullWidth>
      <SectionWrapper dc g={30}>
        <SectionTitle>{title}</SectionTitle>
        <ProjectCards cards={projects} />
        {viewAllButton}
      </SectionWrapper>
    </Relative>
  )
}
